import React, { useState } from 'react';

interface PasswordConfirmModalProps {
  isOpen: boolean;
  onConfirm: (password: string) => void;
  onCancel: () => void;
  title?: string;
  description?: string;
}

const PasswordConfirmModal: React.FC<PasswordConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirmação de Permissão',
  description = 'Informe a senha para realizar esta ação:',
}) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleConfirm = () => {
    if (password.trim()) {
      onConfirm(password);
      setPassword('');
    }
  };

  const handleCancel = () => {
    setPassword('');
    setShowPassword(false);
    onCancel();
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          padding: 32,
          width: 360,
          boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: 8, fontSize: 18 }}>{title}</h3>
        <p style={{ color: '#555', marginBottom: 16 }}>{description}</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleConfirm();
          }}
        >
          <div style={{ position: 'relative', marginBottom: 20 }}>
            <input
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Senha"
              autoFocus
              style={{
                width: '100%',
                padding: '10px 12px',
                paddingRight: 40,
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 15,
                boxSizing: 'border-box',
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: 16,
                color: '#666',
                padding: 4,
              }}
              title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
            >
              <i className={`fas fa-eye${showPassword ? '' : '-slash'}`}></i>
            </button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <button
              type="button"
              onClick={handleCancel}
              style={{
                padding: '8px 20px',
                borderRadius: 4,
                border: '1px solid #ccc',
                background: '#f5f5f5',
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!password.trim()}
              style={{
                padding: '8px 20px',
                borderRadius: 4,
                border: 'none',
                background: password.trim() ? '#007bff' : '#b0c4de',
                color: '#fff',
                cursor: password.trim() ? 'pointer' : 'not-allowed',
                fontSize: 14,
              }}
            >
              Confirmar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordConfirmModal;
